import React from 'react';
import { Box, Typography } from '@mui/material';

import AnimatedLogo from '@common/components/login/animated-logo';

export const LoginLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <AnimatedLogo />
        <Typography variant="text-lg">We are setting up your information.</Typography>
      </Box>
    </Box>
  );
};
